import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import Messages from './messages';
import './feat1.css';


class Features extends Component {
	constructor(props) {
		super(props);
		this.sectionTop = [0];
		this.state = {  
			feat: [],
			featBlocks: [],
			maxHeight: 0,
			featNav: true         
		};
  }

	updateDimensions(){	
		this.getHeight();
  }

  componentDidMount() {
		var mapHolder = document.getElementById('mapHolder');
		window.addEventListener("resize", this.updateDimensions.bind(this));
		mapHolder.classList.add('featOn');
		this.getFeat();
		document.title = "BSA: Core Principles and Objectives 2018"
	}

  componentWillUnmount() {
		window.removeEventListener("resize", this.updateDimensions.bind(this));
		var mapHolder = document.getElementById('mapHolder');
		mapHolder.classList.remove('featOn');
  }

	componentDidUpdate(){
  }

	getFeat = () => {
		const url = window.location.href;
		const currentID = url.split('/')[4];
	

		fetch(('/api/features?'+currentID))
		.then(res => res.json())
		.then(data => this.setState({
					feat: data.feat
					}))
		.then(()=>{
			this.getHeight();
			document.title = "BSA: Core Principles and Objectives 2018"
		})
	}

  getHeight = () => {
	  this.sectionTop = [0]
	  this.setState(
		{featBlocks: [],
		maxHeight: 0}
	  )
	  var args = document.getElementsByClassName('featBlock')
	  var newArgs = Array.prototype.slice.call(args)
	  var startHeight = 0;

	  newArgs.map((currentBlock, i)=>{
		  if(currentBlock.classList.contains('featCover'))
		  {this.sectionTop.push(currentBlock.offsetHeight + startHeight)}

		  startHeight += currentBlock.offsetHeight;
		  this.setState({
			  maxHeight: this.state.maxHeight + currentBlock.offsetHeight
		  })

		  this.setState({
			featBlocks: newArgs
		})
	  });
  }

  featScroll = (e)=>{
		var scrollY = e.target.scrollTop;
		var featMenu = document.getElementsByClassName('featMenu');
		var currentSect= 0;
		var currentID;
		let currentEl;
		var args = document.getElementsByClassName('featBlock')
		var newArgs = Array.prototype.slice.call(args)
		this.sectionTop.map((sect, i)=>{
			if((scrollY >= (sect-window.innerHeight)) && (currentSect !== i) && (i > 0)){
				if(this.sectionTop[i+1]){
					currentSect = i-1;
					currentID = "featNav"+(i-1);
					currentEl = document.getElementById(currentID);
				}
				else{
					currentSect = 9;
					currentID = "featNav"+(9);
					currentEl = document.getElementById(currentID);
				}

				currentSect = i-1;
				currentID = "featNav"+(i-1);
				currentEl = document.getElementById(currentID);
				if(currentEl){
					var currentRed = document.getElementsByClassName('currentFeatSection');
					var redsArg = Array.prototype.slice.call(currentRed)
					if(redsArg){
						redsArg.map((el)=>{
							el.classList.remove('currentFeatSection')
						})
					}
					currentEl.classList.add('currentFeatSection')
				};
			}
		})
		newArgs.map((el)=>{
			this.onVisibilityChange(el, (visible)=>{
				if(visible === 1 && el.nextSibling){
					el.nextSibling.classList.add('fixedElement')
				}

				if(((visible === 2) && el.nextSibling) || ((visible === 0) && el.nextSibling)){
					if(el.nextSibling.classList.contains('fixedElement')){
					el.nextSibling.classList.remove('fixedElement')
					}
				}
			});
		});

		(this.state.featNav) ? (
			scrollY >= 300 ? (
				featMenu[0].classList.add('hideFeatNav'),
				this.setState({featNav: false})
				) : (   
				  ' '
				)
		) : (
			scrollY < 300 ? (
				featMenu[0].classList.remove('hideFeatNav'),
				this.setState({featNav:true})
			) : (
				' '
			)
		)
	}

	isElementInViewport=(el)=> {
		var rect = el.getBoundingClientRect();
		if((rect.bottom < 0 && rect.top <= 0) || (rect.top < 0 && rect.bottom > window.innerHeight) || (rect.top > window.innerHeight)){
			return 2;
		}
		else if (
			(rect.top <= window.innerHeight) && 
			(rect.bottom >= 0) && (rect.bottom <=window.innerHeight)
		) { return 1; }
		else {return 0}
	}

	onVisibilityChange = (el, callback) => {
		var old_visible;
		var visible = this.isElementInViewport(el);
		if (visible >= 1) {
			old_visible = visible;
			if (typeof callback === 'function') {
				callback(visible);
			}
		}
	}

	featScrollTo(e) {
		const scrollThis = (parseInt(e.currentTarget.dataset.id, 10));
		const fixedEl = document.getElementsByClassName('fixedElement')
		var fixedTotal = fixedEl.length;
		var myElement =  document.getElementsByClassName('featHold');
		myElement[0].scrollTop = this.sectionTop[scrollThis]-(window.innerHeight-1);
  }

 
	render() {
		const { feat } = this.state;
		var indexCounter = 0;
		return (
			<React.Fragment>
				{feat.length ? (
					<React.Fragment>
					<Route exact path='/features/principles' render={()=><Messages messageQuotes={feat[0].quotes}/>} />
					<div className="featHold fullWidth fullHeight" onScroll={this.featScroll.bind(this)}>
					   <div className="featFull fullWidth" style={{height:this.state.maxHeight}} >
							{feat.map((feat, i)=>{
								return(
									<React.Fragment key={i}>
									<div className="featNav upperT boldT" key={i}>
										<ol className="featMenu">
											{feat.sections.map((section, i)=>{
												return(
													<li id={"featNav"+(i+1)} className="boldT" key={i} data-id={i+2} onClick={this.featScrollTo.bind(this)}>
														{section.sectTitle}
													</li>
												)
											})}
										</ol>
									</div>
									<div className="featCover featBlock bgCover relative indexCounter" style={{backgroundImage: `url(${feat.images[0].imgURL})`, "height" : (window.innerHeight), "width":(window.innerWidth), zIndex: `${-(indexCounter++)}`}}>
										<div className="titleHold tfStage centeredContent" key={i}>      
												<h1 className="upperT featTitle">{feat.featTitle}</h1>
										</div> 
									</div>  

									{feat.sections.map((section,i) =>{

										return(
											<React.Fragment key={i}>
											<div className="featCover featBlock bgBlack bgCover relative"  key={i} style={section.images.length ? (
												{backgroundImage: `url(${section.images[0].imgURL})`, height : (window.innerHeight), "width":(window.innerWidth), zIndex: `${-(indexCounter++)}`}
										   ):(
											   {"height" : (window.innerHeight), "width":(window.innerWidth), zIndex: `${-(indexCounter++)}`}
										   )}>
											   <div className="sectionDesStage fullStage relative fullHeight">
													<div className="sectionDesHold blkT">
														<h2 className="sectionNumber">{i+1} </h2>
														<h2 className="upperT sectionBorder">{section.sectTitle}</h2>
														<h3>{section.sectTagline}</h3>
													</div>
												</div> 
												
											</div>
											<div className="featBlock bgWhite  blkT featSectContent relative" style={{zIndex: `${-(indexCounter++)}`, "width":(window.innerWidth)}}>
												<h4 className="fullStage marginBotLarge" dangerouslySetInnerHTML={{ __html : section.sectLead }}></h4>
												<div className="fullStage sectCopy" dangerouslySetInnerHTML={{ __html : section.sectCopy }}></div>   
											</div>
											</React.Fragment>
										)}
									)}
									</React.Fragment>
								);
							}
						)}
					</div></div></React.Fragment>
				):( 
					<div className="fullWidth fullHeight redT blinkFast loader">
						<div className="centeredContent">•</div>
					</div>
				)}
			</React.Fragment>
		)
	}
}

export default Features;


// WEBPACK FOOTER //
// ./src/components/features/feat1/feat1.js